import NotFoundPage from "@/pages/NotFoundPage";
import routes from "@/utils/routes";
import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import FinEaseHomeApp from "./projects/FinEaseHomeAndAdmin/app";
import FinEaseUserApp from "./projects/FinEaseUser/app";
import IPOApp from "./projects/IPO/app";
import NewsApp from "./projects/News/app";
import ScreenerUserApp from "./projects/Screener/app";
import ScreenerUserApp2 from "./projects/Screener2/app";

function App() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);
  return <AppRouterWrapper />;
}

const AppRouterWrapper = () => {
  return (
    <BrowserRouter>
      <AppWithRouter />
    </BrowserRouter>
  );
};

const AppWithRouter = () => {
  const publicRoutes = routes.find(m => m.type === "public")?.routes ?? [];
  const authRoutes = routes.find(m => m.type === "auth")?.routes ?? [];

  return (
    <Routes>
      <Route element={<TopLevelComponent />}>
        {/* FinEaseHomeAndAdmin App - handles public routes and admin routes */}
        <Route element={<FinEaseHomeApp />} path="/*" />

        {/* Public routes from global routes config */}
        {publicRoutes.map(({ path, element: Page }) => (
          <Route key={path} path={path} element={<Page />} />
        ))}

        {/* FinEaseUser App - User-only routes (mobile OTP login) */}
        {/* Mounted at /nps-user/* to match navigation routes */}
        <Route element={<FinEaseUserApp />} path="/nps-user/*" />
        {/* News App */}
        <Route element={<NewsApp />} path="/news/*" />

        {/* IPO App */}
        <Route element={<IPOApp />} path="/ipo/*" />
        {/* Screener App */}
        <Route element={<ScreenerUserApp />} path="/screener/*" />
        <Route element={<ScreenerUserApp2 />} path="/screener2/*" />

        {/* Legacy protected routes - these should be handled by individual apps */}
        {/* Keeping for backward compatibility, but individual apps handle their own protection */}
        {authRoutes.map(({ path, element: Page }) => (
          <Route key={path} path={path} element={<Page />} />
        ))}

        {/* 404 - catch all unmatched routes */}
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
};

const TopLevelComponent = () => <Outlet />;

export default App;
